import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import {
  Button,
  Grid } from
'@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { Checkbox } from '@mui/material';


import './gestionLogisticaContent.scss';
import { SelectInput } from '../../../components/selectInput/SelectInput';
import { GET_ESTADOS_LOGISTICA } from '../../../data/graphQL/queries/GestionLogistica/getGestionLogisticaEstado';
import { GET_MOTIVO_LOGISTICA } from '../../../data/graphQL/queries/GestionLogistica/getGestionLogisticaMotivo';
import { GET_GESTION_LOGISTICA_CLIENTE } from '../../../data/graphQL/queries/GestionLogistica/getClienteNombre';
import { TextInput } from '../../../components/textInput/TextInput';
import { UPDATE_INSTANCIA_LOGISTICA } from '../../../data/graphQL/mutations/GestionLogistica/UpdateInstanciaLogistica';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import 'moment/locale/es';
import moment from 'moment';
import { CustomDialog } from '../../../components/customDialog/CustomDialog';

import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';

import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import Map from '../../../components/common/Map';
import credentials from '../../../components/common/credential';
import { GET_PROVEEDOR_DISTRIBUIDOR_BY_CODPOSTAL } from '../../../data/graphQL/queries/ProveedorDistribuidor/getProveedorDistribuidorByCodPostal';
import { CustomChip } from '../../../components/chip/Chip';
import { ReactComponent as Place } from '../../../assets/svg/Place.svg';
import { CustomButton } from '../../../components/customButton/CustomButton';

const mapURL = `https://maps.googleapis.com/maps/api/js?v=3.exp&key=${credentials.mapsKey}`;

export const InstanciasLogisticaContent = ({ setChildrenAction }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const stateData = location.state;
  const [openDlgMapa, setOpenDlgMapa] = useState(false);

  const data = stateData?.solicitud;
  const instancias = data?.instancias;
  const codPostal = data?.ultimaInstancia?.idCodigoPostalNavigation?.idCodigoPostal;
  const latitud = Number(data?.t_EvaluacionPaciente?.idPacienteNavigation?.latitud);
  const longitud = Number(data?.t_EvaluacionPaciente?.idPacienteNavigation?.longitud);

  const paciente = data?.t_EvaluacionPaciente?.idPacienteNavigation?.nombre + ' ' + data?.t_EvaluacionPaciente?.idPacienteNavigation?.apellido;
  const lastInstance = data?.instancias?.reduce((maxObjeto, instanciaActual) => {
    return instanciaActual.nroInstancia > maxObjeto.nroInstancia ? instanciaActual : maxObjeto;
  }, data?.instancias[0]);

  const [nombreCliente, setNombreCliente] = useState('');

  const [zonaDesfavorable, setZonaDesfavorable] = useState(false);

  const [hayCostos, setHayCostos] = useState(false);
  const [estadoSelected, setEstadoSelected] = useState();
  const [motivoSelected, setMotivoSelected] = useState();

  const [open, setOpen] = useState(false);
  const [motivoRechazo, setMotivoRechazo] = useState('');

  const handleClose = () => {
    setOpen(false);
  };
  const [estados, setEstados] = useState([]);
  const [motivos, setMotivos] = useState([]);

  const [distribuidores, setDistribuidores] = useState([]);

  const [distribuidorSelected, setDistribuidorSelected] = useState(lastInstance.idProveedorDistribuidorNavigation.idProveedorDistribuidor);

  const [getEstados, { data: estadosResult, loading: estadosLoading }] = useLazyQuery(GET_ESTADOS_LOGISTICA);

  useEffect(() => {
    if (!estadosResult) return;
    setEstados(estadosResult.allEstadoLogistica?.map((estado) => {return { id: estado.idGestionLogisticaEstado, displayName: estado.descripcion };}));
  }, [estadosResult]);

  const [getMotivos, { data: motivosResult, loading: motivosLoading }] = useLazyQuery(GET_MOTIVO_LOGISTICA);

  useEffect(() => {
    if (!motivosResult) return;
    setMotivos(motivosResult.allMotivoLogistica?.map((motivo) => {return { id: motivo.idGestionLogisticaMotivo, displayName: motivo.descripcion };}));
  }, [motivosResult]);  

  const limpiarDlgGestionar = () => {
    getDistribuidores({
      variables: {
        idCodigoPostal: codPostal
      }
    });
    setEstadoSelected('');
    setMotivoSelected('');
    setZonaDesfavorable(false);
    setMotivoRechazo('');
  };

  const handleClickGestionar = () => {
    limpiarDlgGestionar();
    setOpen(true);
  };

  const Accordion = styled((props) =>
  <MuiAccordion disableGutters elevation={0} square {...props} />
  )(({ theme }) => ({
    width: '100%',
    border: '0px'
  }));

  const AccordionSummary = styled((props) =>
  <MuiAccordionSummary
    expandIcon={<ExpandLessIcon sx={{ fontSize: '24px' }} />}
    {...props} />

  )(({ theme }) => ({
    width: '100%',
    color: 'black',
    borderRadius: 5,
    backgroundColor:
    theme.palette.mode === 'dark' ?
    'rgba(255, 255, 255, .05)' :
    '#fff',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
      transform: 'rotate(180deg)',
      color: 'black'
    },
    '& .MuiAccordionSummary-content': {
      marginLeft: theme.spacing(-1)
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      color: 'black'
    }
  }));

  const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(1),
    border: '0px'
  }));

  const [expanded, setExpanded] = React.useState('');

  const handleChangeInstancia = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };


  useEffect(() => {
    if (!estadosLoading) {
      getEstados();
    }
    if (!motivosLoading) {
      getMotivos();
    }
    if (!distribuidoresLoading) {
      getDistribuidores({
        variables: {
          idCodigoPostal: codPostal
        }
      });
    }
    getClienteNombre({ variables: { codigo: data.t_EvaluacionPaciente?.idPacienteNavigation?.idCliente } });
  }, []);

  const [getClienteNombre, { data: clientData }] = useLazyQuery(GET_GESTION_LOGISTICA_CLIENTE, {
    fetchPolicy: 'cache-and-network'
  });

  useEffect(() => {
    if (!clientData) return;
    if (clientData.clienteByCodigo.success && clientData.clienteByCodigo.valorEsperado != null) {
      setNombreCliente(clientData.clienteByCodigo.valorEsperado.nom_Com);
    }
  }, [clientData]);

  useEffect(() => {

    setChildrenAction(() =>
    lastInstance.idGestionLogisticaEstadoNavigation.idGestionLogisticaEstado != 2 &&
    lastInstance.idGestionLogisticaEstadoNavigation.idGestionLogisticaEstado != 3 &&
    <div className='buttons-preview-actions'>
                <CustomButton
        variant='contained'
        onClick={handleClickGestionar}
        disableElevation
        size='small'>
        
                    Gestionar
                </CustomButton>
            </div>);

  }, [setChildrenAction]);

  const handleClickAgregar = () => {
    if ((estadoSelected == 1 || estadoSelected == 3) && !motivoRechazo) {
      toast.error("El motivo es requerido");
    } else {
      addInstanciaGestion();
    }
  };

  const [addInstanciaGestion] = useMutation(
    UPDATE_INSTANCIA_LOGISTICA,
    {
      variables: {
        idEstado: estadoSelected,
        idEvaluacion: data?.idEvaluacion,
        idMotivo: motivoSelected,
        motivo: motivoRechazo,
        alertarZonaDesfavorable: zonaDesfavorable,
        idDistribuidor: distribuidorSelected
      },
      onCompleted: () => {
        toast.success("Gestión logística grabada correctamente.");
        navigate('/gestionLogistica');
      }
    }
  );

  const handleUbicacion = () => {
    setOpenDlgMapa(true);
  };

  const handleCloseDlgMapa = () => {
    setOpenDlgMapa(false);
  };

  const [getDistribuidores, { data: distribuidoresResult, loading: distribuidoresLoading }] = useLazyQuery(GET_PROVEEDOR_DISTRIBUIDOR_BY_CODPOSTAL);

  useEffect(() => {
    if (!distribuidoresResult) return;
    setDistribuidores(distribuidoresResult.distribuidoresByCodPostal?.map((distribuidor) => {return { id: distribuidor.idProveedorDistribuidor, displayName: distribuidor.codigoSAP + ' - ' + distribuidor.razonSocial, km: distribuidor.proveedorMetodoCobroKM, bulto: distribuidor.proveedorMetodoCobroBulto, kilo: distribuidor.proveedorMetodoCobroKilo };}));
  }, [distribuidoresResult]);

  const [km, setKm] = useState();
  const [bulto, setBulto] = useState();
  const [kilo, setKilo] = useState();

  const handleChangeDistribuidor = (distribuidorId) => {
    setDistribuidorSelected(distribuidorId);
    let setearCosto = false;
    let distribuidor = distribuidores.find((d) => d.id == distribuidorId);
    try {
      const fechaActual = moment().format("yyyy-MM-DD");
      const metodoCobroKM = distribuidor.km.find((metodo) => {
        const fechaDesde = moment(metodo.fechaDesde).format("yyyy-MM-DD");
        const fechaHasta = metodo.fechaHasta != null ? moment(metodo.fechaHasta).format("yyyy-MM-DD") : fechaActual;
        return fechaDesde <= fechaActual && fechaHasta >= fechaActual;
      });

      if (metodoCobroKM) {
        setearCosto = true;
        setKm(metodoCobroKM.valor);
      } else
      {
        setKm();
      }

      const metodoCobroBulto = distribuidor.bulto.find((metodo) => {
        const fechaDesde = moment(metodo.fechaDesde).format("yyyy-MM-DD");
        const fechaHasta = metodo.fechaHasta != null ? moment(metodo.fechaHasta).format("yyyy-MM-DD") : fechaActual;
        return fechaDesde <= fechaActual && fechaHasta >= fechaActual;
      });

      if (metodoCobroBulto) {
        setearCosto = true;
        setBulto(metodoCobroBulto.precio);
      } else
      {
        setBulto();
      }

      const metodoCobroKilo = distribuidor.kilo.find((metodo) => {
        const fechaDesde = moment(metodo.fechaDesde).format("yyyy-MM-DD");
        const fechaHasta = metodo.fechaHasta != null ? moment(metodo.fechaHasta).format("yyyy-MM-DD") : fechaActual;
        return fechaDesde <= fechaActual && fechaHasta >= fechaActual;
      });

      if (metodoCobroKilo) {
        setearCosto = true;
        setKilo(metodoCobroKilo.valor);
      } else
      {
        setKilo();
      }
      console.log(setearCosto, km, bulto, kilo);
      setHayCostos(setearCosto);
    } catch (e) {
      console.log("error!", e);
    }
  };

  const costoInstancia = (instancia) => {
    const fechaActual = moment().format("yyyy-MM-DD");
    const metodoCobroKM = instancia.idProveedorDistribuidorNavigation.proveedorMetodoCobroKM.find((metodo) => {
      const fechaDesde = moment(metodo.fechaDesde).format("yyyy-MM-DD");
      const fechaHasta = metodo.fechaHasta != null ? moment(metodo.fechaHasta).format("yyyy-MM-DD") : fechaActual;
      return fechaDesde <= fechaActual && fechaHasta >= fechaActual;
    });

    const metodoCobroBulto = instancia.idProveedorDistribuidorNavigation.proveedorMetodoCobroBulto.find((metodo) => {
      const fechaDesde = moment(metodo.fechaDesde).format("yyyy-MM-DD");
      const fechaHasta = metodo.fechaHasta != null ? moment(metodo.fechaHasta).format("yyyy-MM-DD") : fechaActual;
      return fechaDesde <= fechaActual && fechaHasta >= fechaActual;
    });

    const metodoCobroKilo = instancia.idProveedorDistribuidorNavigation.proveedorMetodoCobroKilo.find((metodo) => {
      const fechaDesde = moment(metodo.fechaDesde).format("yyyy-MM-DD");
      const fechaHasta = metodo.fechaHasta != null ? moment(metodo.fechaHasta).format("yyyy-MM-DD") : fechaActual;
      return fechaDesde <= fechaActual && fechaHasta >= fechaActual;
    });

    return (
      <>
                {
        metodoCobroKM &&
        <CustomChip
          label={'Km $ ' + metodoCobroKM.valor}
          isLightBlue />

        }
                {
        metodoCobroBulto &&
        <CustomChip
          label={'Bulto $ ' + metodoCobroBulto.precio}
          isLightBlue />

        }
                {
        metodoCobroKilo &&
        <CustomChip
          label={'Peso $ ' + metodoCobroKilo.valor}
          isLightBlue />

        }
            </>);

  };

  useEffect(() => {
    if (open) {
      handleChangeDistribuidor(lastInstance.idProveedorDistribuidorNavigation.idProveedorDistribuidor);
    }
  }, [distribuidores]);

  return (
    <>
            <div className='solic-info-content'>
                Número de contrato: <strong>{data.nroContrato.toString().trim()}</strong>
                <strong>|</strong>
                Paciente: <strong>{data.paciente}</strong>
                <strong>|</strong>
                Cliente: <strong>{nombreCliente != "" ? nombreCliente : '-'}</strong>
            </div>
            {
      instancias.map((instancia) =>
      <div className='card-container'>
                        <Accordion
          key={instancia.nroInstancia}
          expanded={expanded === `panel${instancia.nroInstancia}`}
          onChange={handleChangeInstancia(`panel${instancia.nroInstancia}`)}>
          
                            <AccordionSummary>
                                <strong>Instancia: {instancia.nroInstancia}</strong>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div>
                                    <Grid
                container
                justifyContent={'space-between'}
                columns={{
                  xs: 2,
                  md: 5
                }}
                rowGap={3}>
                
                                        <Grid size={{ md: 1 }}>
                                            <div className='instancia-dato'>
                                                <strong>Código Postal:</strong>
                                                <label>{instancia.idCodigoPostalNavigation?.cP}</label>
                                            </div>
                                        </Grid>
                                        <Grid size={{ md: 1 }}>
                                            <div className='instancia-dato'>
                                                <strong>Dirección</strong>
                                                <div>
                                                    <label>{instancia.direccion}</label>
                                                    <Place onClick={handleUbicacion} style={{ cursor: 'pointer', marginTop: '-5px' }} />
                                                </div>
                                            </div>
                                        </Grid>
                                        <Grid size={{ md: 1 }}>
                                            <div className='instancia-dato'>
                                                <strong>Localidad</strong>
                                                <label>{instancia.idCodigoPostalNavigation.localidad}</label>
                                            </div>
                                        </Grid>
                                        <Grid size={{ md: 1 }}>
                                            <div className='instancia-dato'>
                                                <strong>Provincia</strong>
                                                <label>{instancia.provincia}</label>
                                            </div>
                                        </Grid>
                                        <Grid size={{ md: 1 }}>
                                            <div className='instancia-dato'>
                                                <strong>Tipo zona</strong>
                                                <label>{instancia.idCodigoPostalNavigation?.idTipoZonaNavigation?.descripcion}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 5 }}>
                                            <div className='instancia-dato'>
                                                <strong>Observaciones</strong>
                                                <label>{instancia.observacion}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.6 }}>
                                            <div className='instancia-dato'>
                                                <strong>Código distribuidor</strong>
                                                <label>{instancia.idProveedorDistribuidorNavigation.codigoSAP}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.6 }}>
                                            <div className='instancia-dato'>
                                                <strong>Nombre</strong>
                                                <label>{instancia.idProveedorDistribuidorNavigation.razonSocial}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.6 }}>
                                            <div className='instancia-dato'>
                                                <strong>Costo</strong>
                                                <div>
                                                    {costoInstancia(instancia)}
                                                </div>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.25 }}>
                                            <div className='instancia-dato'>
                                                <strong>Alertar zona desfavorable</strong>
                                                <label>{instancia.alertarZonaDesfavorable ? 'SI' : 'NO'}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.25 }}>
                                            <div className='instancia-dato'>
                                                <strong>Tipo envio</strong>
                                                <label>{instancia.envioEspecial ? "Especial" : "Normal"}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.25 }}>
                                            <div className='instancia-dato'>
                                                <strong>Estado</strong>
                                                <label>{instancia.idGestionLogisticaEstadoNavigation.descripcion}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.25 }}>
                                            <div className='instancia-dato'>
                                                <strong>Motivo</strong>
                                                <label>{instancia.idGestionLogisticaMotivoNavigation.descripcion}</label>
                                            </div>
                                        </Grid>

                                        <Grid size={{ md: 1.25 }}>
                                            <div className='instancia-dato'>
                                                <strong>Gestionado por</strong>
                                                <label>{instancia.idGestionUsuarioNavigation?.apellido}  {instancia?.idGestionUsuarioNavigation?.nombre}</label>
                                            </div>
                                        </Grid>
                                        <Grid size={{ md: 3.75 }}>
                                            <div className='instancia-dato'>
                                                <strong>Fecha y Hora</strong>
                                                <label>{moment(instancia.fechaNotificacion).format('DD/MM/yyyy')}</label>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    {
              instancia.fechaLogistica &&
              <div className='instancia-gestion'>
                                            <Grid
                  container
                  columns={{
                    xs: 1,
                    md: 5
                  }}
                  rowGap={2}>
                  
                                                <Grid size={{ xs: 1, md: 1.25 }}>
                                                    <div className='instancia-dato'>
                                                        <strong>Usuario gestión</strong>
                                                        <label>{instancia.idUsuarioLogisticaNavigation?.apellido}  {instancia?.idUsuarioLogisticaNavigation?.nombre}</label>
                                                    </div>
                                                </Grid>
                                                <Grid size={{ xs: 1, md: 3.75 }}>
                                                    <div className='instancia-dato'>
                                                        <strong>Fecha gestión</strong>
                                                        <label>{moment(instancia.fechaLogistica).format('DD/MM/yyyy')}</label>
                                                    </div>
                                                </Grid>

                                                <Grid size={{ xs: 1 }}>
                                                    <div className='instancia-dato'>
                                                        <strong>Observación gestión</strong>
                                                        <label>{instancia.observacionLogistica}</label>
                                                    </div>
                                                </Grid>
                                            </Grid>
                                        </div>
              }
                                </div>
                            </AccordionDetails>
                        </Accordion>
                    </div>
      )
      }


            <CustomDialog
        open={open}
        onClose={handleClose}
        maxWidth='md'
        fullWidth={true}
        title={'Gestión de instancia'}
        onCancel={handleClose}
        onAccept={handleClickAgregar}
        acceptText='Aplicar'
        cancelText='Cerrar'>
        
                <div className='dialog-content'>
                    <Grid
            container
            justifyContent={'space-between'}
            columns={{
              xs: 1,
              md: 2
            }}
            rowGap={1}
            spacing={2}>
            
                        <Grid size={{ md: 1.5 }}>
                            <SelectInput
                options={distribuidores}
                label='Distribuidor'
                onChange={(e) => {handleChangeDistribuidor(e.target.value);}}
                value={distribuidorSelected} />
              
                        </Grid>
                        <Grid size={{ md: 0.5 }}>
                            <div className='alertar-zona-content'>
                                <label>Alertar zona desfavorable</label>
                                <Checkbox checked={zonaDesfavorable} onChange={(e) => setZonaDesfavorable(e.target.checked)} />
                            </div>
                        </Grid>
                        {hayCostos &&
            <Grid size={{ md: 2 }}>
                                <div className='gestion-distribuidor-costos'>
                                    <strong>Costo</strong>
                                    {bulto &&
                <CustomChip
                  label={'Bulto $ ' + bulto}
                  isLightBlue="true" />

                }
                                    {km &&
                <CustomChip
                  label={'Km $ ' + km}
                  isLightBlue="true" />

                }
                                    {kilo &&
                <CustomChip
                  label={'Peso $ ' + kilo}
                  isLightBlue="true" />

                }
                                </div>
                            </Grid>
            }
                        <Grid size={{ md: 1 }}>
                            <SelectInput
                label='Estado'
                onChange={(e) => {setEstadoSelected(e.target.value);}}
                value={estadoSelected}
                options={estados} />
              
                        </Grid>
                        <Grid size={{ md: 1 }}>
                            <SelectInput
                options={motivos}
                label='Motivo'
                onChange={(e) => {setMotivoSelected(e.target.value);}}
                value={motivoSelected} />
              
                        </Grid>
                        <Grid size={{ md: 2 }}>
                            <TextInput
                id="name"
                label="Observaciones"
                type="text"
                fullWidth
                value={motivoRechazo}
                onChange={(e) => setMotivoRechazo(e.target.value)}
                multiline={true}
                rows={4} />
              
                        </Grid>
                    </Grid>
                </div>
            </CustomDialog>

            <CustomDialog
        maxWidth="lg"
        fullWidth={true}
        open={openDlgMapa}
        title={'Geo Posicionamiento de Direcciones'}
        onCancel={handleCloseDlgMapa}
        cancelText='Cerrar'>
        
                <div className='dialog-content'>
                    <Grid
            container
            justifyContent={'space-between'}
            columns={{
              xs: 1,
              md: 3
            }}
            rowGap={1}
            spacing={2}>
            
                        <Grid size={{ xs: 1, md: 1 }}>
                            <TextInput
                label='Dirección'
                placeholder='Dirección'
                value={lastInstance.direccion}
                disabled="true" />
              
                        </Grid>
                        <Grid size={{ xs: 1, md: 1 }}>
                            <TextInput
                label='Localidad'
                placeholder='Localidad'
                value={lastInstance.idCodigoPostalNavigation.localidad}
                disabled="true" />
              
                        </Grid>
                        <Grid size={{ xs: 1, md: 1 }}>
                            <TextInput
                label='Provincia'
                placeholder='Provincia'
                value={lastInstance.provincia}
                disabled="true" />
              
                        </Grid>
                        <Grid size={{ xs: 1, md: 3 }}>
                            <Map
                googleMapURL={mapURL}
                containerElement={<div style={{ height: '400px' }} />}
                mapElement={<div style={{ height: '100%' }} />}
                loadingElement={<CircularProgress disableShrink />}
                latitud={latitud}
                longitud={longitud}
                usuario={paciente} />
              
                        </Grid>
                    </Grid>
                </div>
            </CustomDialog>

            <Outlet />

        </>);
};